import { Box, Stepper, Step, StepLabel, Button } from '@mui/material'
import React, { useState } from 'react'
import BasicModal from '../../../components/shared/modals/BaseModal'
import { Add } from '@mui/icons-material'
import FilterButton from '../../../components/buttons/FilterButton'
import BasicTab from '../../../components/Tabs/BasicTab'
import IsbnForm from '../../../components/forms/IsbnForm'
import DataForm from '../../../components/forms/DataForm'
import CadObra from './CadObra'
import { func, number } from 'prop-types'
import FormExemplar from '../../exemplar/components/FormExemplar'
import { useNavigate } from 'react-router-dom'
import rotas from '../../../services/rotas'

const OpenButton = ({ ...props }) => (
  <FilterButton
    color="white"
    Icon={Add}
    text="Cadastrar"
    {...props}
    bg="#000000BF"
  />
)

const CadLivroModal = ({ getBooks }) => {
  const [obraId, setObraId] = useState(-1)
  const [obraTitulo, setObraTitulo] = useState('')

  const navigate = useNavigate()

  const [form, setForm] = useState({
    isbn: '',
    titulo: '',
    categoria: '',
    categoria_name: '',
    categoria_obra_id: '',
    palavra_chave: '',
    editora: '',
    editora_id: '',
    numero_edicao: '',
    numero_pagina: '',
    data_publicacao: '',
    autores: '',
    autores_id: ''
  })

  const reset = () => {
    setForm({
      isbn: '',
      titulo: '',
      categoria: '',
      categoria_name: '',
      categoria_obra_id: '',
      palavra_chave: '',
      editora: '',
      editora_id: '',
      numero_edicao: '',
      numero_pagina: '',
      data_publicacao: '',
      autores: '',
      autores_id: ''
    })
    setStep(0)
  }

  const [status, setStatus] = useState(false)

  const [step, setStep] = React.useState(0)

  const handleChange = (event, newValue) => {
    setStep(newValue)
  }

  const steps = [
    'Buscar obra pelo ISBN',
    'Informar os dados',
    'Finalizar',
    'Cadastrar 1° exemplar'
  ]
  const FormBackButton = ({ backTo }) => {
    return (
      <Button
        onClick={e => {
          handleChange(e, backTo)
        }}
        variant="outlined"
        color="error"
      >
        Voltar
      </Button>
    )
  }
  FormBackButton.propTypes = {
    backTo: number
  }

  const submitEnd = () => {
    getBooks()
    setStatus(false)
  }

  return (
    <BasicModal
      title="Cadastrar Livro"
      status={status}
      Caller={OpenButton}
      closeEvent={event => {
        setStatus(event)
        reset()
      }}
      sx={{
        minWidth: '60vw',
        width: { xs: '100vw', md: '60vw' }
      }}
      canClose={step !== 3}
    >
      <>
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={step} alternativeLabel>
            {steps.map(label => (
              <Step color="leitura" key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <BasicTab value={step} index={0}>
          <IsbnForm
            form={form}
            handleChange={handleChange}
            onFormChange={e => {
              setForm(e)
            }}
            close={event => setStatus(event)}
          />
        </BasicTab>
        <BasicTab value={step} index={1}>
          <DataForm
            form={form}
            handleChange={handleChange}
            onFormChange={e => {
              setForm(e)
            }}
            BackButton={<FormBackButton backTo={0} />}
            close={event => setStatus(event)}
          />
        </BasicTab>
        <BasicTab value={step} index={2}>
          <CadObra
            form={form}
            onFormChange={e => {
              setForm(e)
            }}
            submitEnd={submitEnd}
            handleChange={handleChange}
            BackButton={<FormBackButton backTo={1} />}
            submitMethod="post"
            onStoreEnd={({ obra_id, obra_titulo }) => {
              setObraId(parseInt(obra_id))
              setObraTitulo(obra_titulo)
            }}
          />
        </BasicTab>
        <BasicTab value={step} index={3}>
          <FormExemplar
            submitMethod="post"
            idObra={obraId}
            onSubmit={() => {
              navigate(`${rotas.livro}/${parseInt(obraId)}/&name:${obraTitulo}`)
            }}
          />
        </BasicTab>
      </>
    </BasicModal>
  )
}

CadLivroModal.propTypes = {
  getBooks: func
}

export default CadLivroModal
